import EmptyState from '../EmptyState';

export function NoRunsDisclaimer() {
  return (
    <div className="py-10">
      <EmptyState title="No runs found" />
    </div>
  );
}
